import { ReceiveItemBatch } from 'src/features/transfers/TransfersTypes'
import * as S from './ReceiveItemBatchesTable.styles'
import { Typography } from '@mui/material'
import { formatDateReplaceHour } from 'src/utils/formatDate'

interface ReceiveItemBatchesTableProps {
  batches: ReceiveItemBatch[]
}

const ReceiveItemBatchesTable = ({
  batches,
}: ReceiveItemBatchesTableProps) => {
  const tableColumns = ['Nº Etiqueta', 'Validade', 'Qtd.']

  return (
    <S.Container>
      <S.Row style={{
        position: 'sticky', top: 0, background: '#EFEFEF', zIndex: 1,
      }}
      >
        {tableColumns.map((column, index) => (
          <S.Column key={index}>
            <Typography sx={{ fontWeight: 'bold' }}>{column}</Typography>
          </S.Column>
        ))}
      </S.Row>
      {batches.map((batch) => (
        <S.Row
          key={batch.idBatchStockExpiration}
          data-testid='batch-table-row-test-id'
        >
          <S.Column>
            <Typography>{batch.batchNumber || '-'}</Typography>
          </S.Column>
          <S.Column>
            <Typography>{formatDateReplaceHour(new Date(batch.expirationDate))}</Typography>
          </S.Column>
          <S.Column>
            <Typography>{batch.quantity}</Typography>
          </S.Column>
        </S.Row>
      ))}
    </S.Container>
  )
}

export default ReceiveItemBatchesTable
